export const ERROR_TEXT = 'Tienes que ingresar un número.';
export const ESTIMATION_CONTAINER_TITLE = 'Resultado:';

export const INPUT_TYPES = {
  'Input - Number with Decimal': 'decimal',
  'Input - Number without Decimal': 'number',
};

type Placement = 'bottom' | 'top';
export const TOOL_TIP = {
  SIZE: 240,
  PLACEMENT: 'bottom' as Placement,
  BACKGROUND_COLOR: '#F9F9F9',
};

type INPUT_VARIANTS = 'outline' | 'flushed' | 'baseline';

export const inputVarients = {
  falabella: 'baseline' as INPUT_VARIANTS,
  sodimac: 'outline' as INPUT_VARIANTS,
};

export const QUANTITY_REQUIRED = 'quantity-required';
export const PRODUCT_COUNT = 'product-count';

export const THEMES = {
  FALABELLA: 'falabella',
  SODIMAC: 'sodimac',
};

export const CUSTOM_REGEX = {
  'Input - Number with Decimal': /^\d{0,4}([.,]\d{0,2})?$/,
  'Input - Number without Decimal': /^\d{0,4}$/,
};
